import useInView from '../hooks/useInView';

/**
 * Wraps children in a scroll-reveal container.
 *
 * Props:
 * variant – 'up' | 'left' | 'right' | 'fade' | 'scale' (default: 'up')
 * delay – CSS delay string e.g. '0.1s' (default: '0s')
 * duration – CSS duration string (default: '0.65s')
 * as – HTML tag to render (default: 'div')
 * style – extra styles on the wrapper
 */
export default function Reveal({
 children,
 variant = 'up',
 delay = '0s',
 duration = '0.65s',
 as: Tag = 'div',
 style = {},
 className = '',
}) {
 const [ref, visible] = useInView();

 const transforms = {
 up: 'translateY(36px)',
 down: 'translateY(-24px)',
 left: 'translateX(-36px)',
 right: 'translateX(36px)',
 fade: 'none',
 scale: 'scale(0.94)',
 };

 return (
 <Tag
 ref={ref}
 className={className}
 style={{
 opacity: visible ? 1 : 0,
 transform: visible ? 'none' : (transforms[variant] || transforms.up),
 transition: `opacity ${duration} cubic-bezier(0.22,1,0.36,1) ${delay},
 transform ${duration} cubic-bezier(0.22,1,0.36,1) ${delay}`,
 ...style,
 }}
 >
 {children}
 </Tag>
 );
}
